import { Home, NotListedLocation } from "@mui/icons-material";
import { Box, Typography, Grid } from "@mui/material";
import { Section } from "react-headings";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";

import { Heading } from "foundations/Heading/Heading";
import Logo from "components/Shared/Logo";
import { RouterMuiButton } from "foundations/RouterLink/RouterMuiButton";

export function NotFoundPage() {
  const intl = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            defaultMessage: "Page Not Found",

            description:
              "The browser title text for the not found page that a user will encounter when they visit an unknown URL in the app",
          })}
        </title>
      </Helmet>
      <main id="main" tabIndex={-1}>
        <Section
          component={
            <Heading hidden>
              <FormattedMessage
                defaultMessage="Page Not Found"
                description="The heading text for the not found page that a user will encounter when they visit an unknown URL in the app"
              />
            </Heading>
          }
        >
          <Grid
            container
            wrap="nowrap"
            sx={{
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              minHeight: "100vh",
            }}
          >
            <Grid
              size={{
                xs: 12,
                sm: 10,
                md: 8,
              }}
            >
              <Box
                sx={(theme) => ({
                  color: theme.palette.text.primary,
                  fontSize: 196,
                })}
                title={intl.formatMessage({
                  defaultMessage: "404 Not Found",

                  description: "The 404 not found error message",
                })}
              >
                {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
                <span aria-hidden="true">4</span>
                <NotListedLocation
                  color="primary"
                  fontSize="inherit"
                  aria-hidden="true"
                  sx={{ verticalAlign: "sub" }}
                />
                {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
                <span aria-hidden="true">4</span>
              </Box>

              <Grid
                container
                spacing={1}
                wrap="nowrap"
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid>
                  <Typography
                    variant="h6"
                    component="h1"
                    color="textSecondary"
                    sx={{
                      fontWeight: "bold",
                      mt: 4,
                      mb: 10,
                    }}
                  >
                    <FormattedMessage
                      defaultMessage="The page you're trying to access doesn't exist."
                      description="Message that appears when you visit a URL of the app that does not exist"
                    />
                  </Typography>
                </Grid>
              </Grid>

              <RouterMuiButton
                to="/"
                variant="contained"
                color="primary"
                size="large"
                startIcon={<Home />}
                sx={(theme) => ({ marginBottom: theme.spacing(7) })}
              >
                <FormattedMessage
                  defaultMessage="Return To Home"
                  description="Button label for link that redirects to home page"
                />
              </RouterMuiButton>

              <Box
                sx={{
                  mb: 3,
                }}
              >
                <Logo coloredDefault isSessionLogo maxHeight="45px" />
              </Box>
            </Grid>
          </Grid>
        </Section>
      </main>
    </>
  );
}
